export const getters = {
    getActivated(state) {
        return state.activated;
    },
    isBuyingPack(state) {
        return state.is_buying_pack;
    },
    lastPaymentMethod(state) {
        return state.last_payment_method;
    },
    get(state) {
        return { ...state };
    },
};

export default getters;
